module.exports = __webpack_public_path__ + "static/media/moon-win.696a7ea2.png";